let genreList = [
    {
        name: '短剧',
        value: 0
    },
    {
        name: '漫剧',
        value: 1
    },
]
export default genreList